// extracted by mini-css-extract-plugin
export default {"root":"Header_root__CGOzu","icon":"Header_icon__PPqnG"};